<div class="idp-content-expander">
  <div
    [ngClass]="[
      'idp-content-expander__container-' + content.actionBar.label.position,
      'idp-content-expander__container'
    ]"
  >
    <div
      *ngIf="content.actionBar.label.show && content.actionBar.label.text"
      (click)="showContent(content, controller)"
      [ngClass]="
        content.actionBar.label.type === 'link'
          ? 'idp-content-expander__label--link'
          : 'idp-content-expander__label--text'
      "
      [id]="content.actionBar.label.id + '_text'"
      tabindex="{{ content.actionBar.label.type === 'link' ? 0 : -1 }}"
      (keypress)="showContent(content, controller)"
    >
      {{ content.actionBar.label.text }}
      <span class="sr-only">
        {{ content.actionBar.label.ariaLabel }}
      </span>
    </div>
    <div
      *ngIf="content.actionBar.caret.show"
      [ngClass]="[
        'idp-content-expander__action-bar-' + content.actionBar.caret.position,
        'idp-content-expander__action-bar'
      ]"
    >
      <idp-action-bar
        (notify)="showContent(content, controller)"
        [content]="content.actionBar"
        [expand]="controller.expand"
      ></idp-action-bar>
    </div>
  </div>
</div>
